import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { KEYS, readJson, writeJson } from './storage';
import { DEMO_NOW_UTC } from '@/fixtures/scenarios';

const SessionContext = createContext(null);

const ROLE = 'admin';

/** Brukeren som vises i portalen (navn og tittel). Kun visning – ingen konto, passord eller tilgangsstyring. */
export const PORTAL_USER = { name: 'Robert Myklebust', title: 'Daglig leder', username: 'robert.myklebust' };

function normalize(s) {
  if (!s) return null;
  return { ...s, role: ROLE, demoUser: PORTAL_USER.name, displayName: PORTAL_USER.name, title: PORTAL_USER.title };
}

/**
 * Prototypeøkt med én innlogging og full tilgang. Ikke en sikkerhetsgrense – ingen passord lagres eller valideres.
 * Backend må håndheve organisasjon og sesjon før virkelige data brukes.
 */
export function SessionProvider({ children }) {
  const [session, setSession] = useState(() => normalize(readJson(window.sessionStorage, KEYS.session, null)));

  const openDemo = useCallback(() => {
    const s = { role: ROLE, demoUser: PORTAL_USER.name, displayName: PORTAL_USER.name, title: PORTAL_USER.title, startedAt: new Date().toISOString(), demoClock: DEMO_NOW_UTC, simulated: true };
    writeJson(window.sessionStorage, KEYS.session, s);
    setSession(s);
    return s;
  }, []);

  const logout = useCallback(() => {
    window.sessionStorage.removeItem(KEYS.session);
    window.localStorage.removeItem(KEYS.lastView);
    setSession(null);
  }, []);

  const value = useMemo(() => ({ session, role: session?.role ?? null, openDemo, logout }), [session, openDemo, logout]);
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession() {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useSession utenfor SessionProvider');
  return ctx;
}
